import React from 'react';

import Slide from '@mui/material/Slide';
import { type TransitionProps } from '@mui/material/transitions';

const SlideTransition = (props: TransitionProps) => {
  // @ts-ignore TODO: test this
  return <Slide {...props} direction="up" />;
};

export default SlideTransition;
